import React, { useCallback, useState, useEffect } from "react";
import { useStore } from "stores/connect";
import { Input } from "components/bootstrap";
import { Spinner } from "components/common";
import { NodesStore } from "stores/nodes/NodesStore";
const NodeOrGlobalSelect = ({ global = false, node = void 0, onChange }) => {
  const { nodes } = useStore(NodesStore);
  const [globalState, setGlobal] = useState(global);
  const [nodeState, setNode] = useState(node);
  useEffect(() => {
    if (!node && nodes) {
      const nodeIds = Object.keys(nodes);
      if (nodeIds.length === 1) {
        onChange("node", nodeIds[0]);
        setNode(nodeIds[0]);
      }
    }
  }, [nodes]);
  const _onChangeGlobal = useCallback(
    (evt) => {
      const isGlobal = evt.target.checked;
      setGlobal(isGlobal);
      if (isGlobal) {
        setNode("placeholder");
        onChange("node", void 0);
      } else {
        onChange("node", nodeState);
      }
      onChange("global", isGlobal);
    },
    [onChange, nodeState, setNode, setGlobal]
  );
  const _onChangeNode = useCallback(
    (evt) => {
      setNode(evt.target.value);
      onChange("node", evt.target.value);
    },
    [setNode, onChange]
  );
  if (!nodes) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const options = Object.keys(nodes).map((nodeId) => /* @__PURE__ */ React.createElement("option", { key: nodeId, value: nodeId }, nodes[nodeId].short_node_id, " / ", nodes[nodeId].hostname));
  const nodeSelect = !globalState ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "node-select",
      type: "select",
      label: "Node",
      placeholder: "placeholder",
      value: node,
      help: "On which node should this input start",
      onChange: _onChangeNode,
      required: true
    },
    /* @__PURE__ */ React.createElement("option", { key: "placeholder", value: "" }, "Select Node"),
    options
  ) : null;
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "global-checkbox",
      type: "checkbox",
      label: "Global",
      help: "Should this input start on all nodes",
      checked: globalState,
      onChange: _onChangeGlobal
    }
  ), nodeSelect);
};
export default NodeOrGlobalSelect;
